import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CloseThick = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, ...props }, forwardedRef) => {
    return (
      <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M2 9L6.5 13.5L14 3" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
)

export default CloseThick
